"use client"

import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './Sidebar.css';
import { API_ENDPOINTS } from '../config/api';
import { getMenuItems } from '../config/menuItems';

const Sidebar = () => {
  const location = useLocation();
  const { t } = useTranslation();
  const [userRole, setUserRole] = useState(null);
  const [userFaculty, setUserFaculty] = useState(null);
  const [userProgram, setUserProgram] = useState(null);

  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();

    const checkUserRole = async () => {
      const akademisyenId = sessionStorage.getItem('akademisyen_id');
      if (!akademisyenId) return;

      try {
        const response = await fetch(API_ENDPOINTS.ROLES_ASSIGNMENTS, {
          signal: controller.signal,
          headers: {
            'Content-Type': 'application/json',
          }
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const assignments = await response.json();

        if (isMounted) {
          const userAssignments = assignments.filter(assignment =>
            assignment.akademisyen_id === parseInt(akademisyenId) && assignment.is_active
          );

          if (userAssignments.length > 0) {
            const primaryRole = userAssignments[0];
            setUserRole(primaryRole.role_name);
            setUserFaculty(primaryRole.faculty_name);
            setUserProgram(primaryRole.program_name);
          }
        }
      } catch (error) {
        // Abort edilmişse veya hata oluşursa sessizce yoksay
      }
    };

    checkUserRole();

    return () => {
      isMounted = false;
      controller.abort();
    };
  }, []);

  const menuItems = getMenuItems(userRole, t);

  return (
    <div className="sidebar">
      {(userRole === 'Dekan' || userRole === 'Program Başkanı' || userRole === 'Rektör' || userRole === 'Rektör Yardımcısı') && (
        <div className="role-info">
          <div className="role-badge">{userRole}</div>
          {userFaculty && <div className="faculty-info">{userFaculty}</div>}
          {userProgram && <div className="faculty-info">{userProgram}</div>}
        </div>
      )}

      {menuItems.map((item) => (
        <Link
          key={item.path}
          to={item.path}
          className={`sidebar-item ${location.pathname === item.path ? 'active' : ''}`}
        >
          <span className="sidebar-label">{item.label}</span>
        </Link>
      ))}

    </div>
  );
};

export default Sidebar;
